<script>
  /**
   * Bulma 式のシンプルなラジオ ボタン
   */
  import Field from './Field.svelte'
  import { scrollOnFocus } from '../../modules/scrollOnFocus'

  export let id
  export let name
  export let label
  export let required
  export let values = []
  export let selected // 選択された値
</script>

<Field {id} {label}>
  {#each values as value}
    <label class="radio">
      <input
        type="radio"
        {name}
        {value}
        {required}
        bind:group={selected}
        use:scrollOnFocus
      />
      {value}
    </label>
  {/each}
</Field>
